<div class="btn-group btn-group-sm" role="group">
  <button
    class="btn"
    (click)="changeDur({ dur: '90m/1m', last_n: 60 })"
    [ngClass]="{ active: dur === '90m/1m' }"
    [disabled]="dur === '90m/1m' || !enabled"
    type="button"
  >
    <span class="d-md-none">1h</span
    ><span class="d-none d-md-inline">1 hour</span>
  </button>
  <button
    class="btn"
    (click)="changeDur({ dur: '90h/1h', last_n: 24 })"
    [ngClass]="{ active: dur === '90h/1h' }"
    [disabled]="dur === '90h/1h' || !enabled"
    type="button"
  >
    <span class="d-md-none">1d</span
    ><span class="d-none d-md-inline">1 day</span>
  </button>
  <button
    class="btn"
    (click)="changeDur({ dur: '90d/1d', last_n: 7 })"
    [ngClass]="{ active: dur === '90d/1d' && lastN == 7 }"
    [disabled]="(dur === '90d/1d' && lastN == 7) || !enabled"
    type="button"
  >
    <span class="d-md-none">7d</span
    ><span class="d-none d-md-inline">7 days</span>
  </button>
  <button
    class="btn"
    (click)="changeDur({ dur: '90d/1d', last_n: 30 })"
    [ngClass]="{ active: dur === '90d/1d' && lastN == 30 }"
    [disabled]="(dur === '90d/1d' && lastN == 30) || !enabled"
    type="button"
  >
    <span class="d-md-none">30d</span
    ><span class="d-none d-md-inline">30 days</span>
  </button>
  <button
    class="btn"
    (click)="changeDur({ dur: '90d/1d', last_n: 90 })"
    [ngClass]="{ active: dur === '90d/1d' && lastN == 90 }"
    [disabled]="(dur === '90d/1d' && lastN == 90) || !enabled"
    type="button"
  >
    <span class="d-md-none">90d</span
    ><span class="d-none d-md-inline">90 days</span>
  </button>
</div>
